import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThreadEmpty = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 166,
	height: 166,
	viewBox: "0 0 166 166",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M165.905 83C165.905 128.787 128.787 165.905 83 165.905C37.2131 165.905 0.0954023 128.787 0.0954023 83C0.0954023 37.2131 37.2131 0.0954023 83 0.0954023C128.787 0.0954023 165.905 37.2131 165.905 83Z",
			fill: "url(#paint0_radial_7_118052)",
			fillOpacity: .2,
			stroke: "#561090",
			strokeWidth: .190805
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M141.005 83.0001C141.005 115.088 114.993 141.1 82.9049 141.1C50.8171 141.1 24.8049 115.088 24.8049 83.0001C24.8049 50.9123 50.8171 24.9001 82.9049 24.9001C114.993 24.9001 141.005 50.9123 141.005 83.0001Z",
			fill: "url(#paint1_radial_7_118052)",
			fillOpacity: .4,
			stroke: "#561090",
			strokeWidth: .190805
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_bddi_7_118052)",
			children: /* @__PURE__ */ _jsx("ellipse", {
				cx: 83.1578,
				cy: 83.1587,
				rx: 36.3521,
				ry: 36.3521,
				fill: "white",
				fillOpacity: .8,
				shapeRendering: "crispEdges"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_7_118052)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M86.1678 68.7441V71.912H70.3281V93.1136L73.1203 90.9197H95.6716V79.8319H98.8395V92.5036C98.8395 93.3785 98.1304 94.0876 97.2556 94.0876H74.216L67.1602 99.6315V70.3281C67.1602 69.4533 67.8693 68.7441 68.7441 68.7441H86.1678ZM94.0876 68.7441V63.9922H97.2556V68.7441H102.007V71.912H97.2556V76.6639H94.0876V71.912H89.3357V68.7441H94.0876Z",
				fill: "url(#paint2_linear_7_118052)"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_bddi_7_118052",
				x: 20.195,
				y: 37.3028,
				width: 125.925,
				height: 125.925,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 2.37595
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_7_118052"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .475191 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0705882 0 0 0 0 0.0117647 0 0 0 0 0.243137 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_backgroundBlur_7_118052",
						result: "effect2_dropShadow_7_118052"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 17.1069 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 13.3053 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0705882 0 0 0 0 0.0117647 0 0 0 0 0.243137 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_7_118052",
						result: "effect3_dropShadow_7_118052"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect3_dropShadow_7_118052",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.80153 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect4_innerShadow_7_118052"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_7_118052",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(83 83) rotate(90) scale(83 83)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .838542,
					stopColor: "#561090",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#561090"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_7_118052",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(82.9049 83.0001) rotate(90) scale(58.1954 58.1954)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .838542,
					stopColor: "#561090",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#561090"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_7_118052",
				x1: 67.1602,
				y1: 100.209,
				x2: 109.235,
				y2: 86.9812,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#7106EE" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .117896,
						stopColor: "#7106EE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .213837,
						stopColor: "#7206EF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2912,
						stopColor: "#7306EF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .353363,
						stopColor: "#7505F0"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .403704,
						stopColor: "#7605F1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4456,
						stopColor: "#7804F2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .48243,
						stopColor: "#7B04F4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .51757,
						stopColor: "#7D04F5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5544,
						stopColor: "#8003F6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .596296,
						stopColor: "#8202F8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .646637,
						stopColor: "#8502F9"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7088,
						stopColor: "#8801FB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .786163,
						stopColor: "#8A01FC"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .882104,
						stopColor: "#8D00FE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#8F00FF"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_7_118052",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 38.0153,
					height: 38.0153,
					fill: "white",
					transform: "translate(63.9922 63.9922)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgThreadEmpty);
export default ForwardRef;
